import { CommunityFeedItem } from '@flipster/apis/v1/community/types';

export function getSegmentPositionStatus(positionCardType: CommunityFeedItem['positionCardType']) {
  switch (positionCardType) {
    case 'OPEN':
    case 'HOLD':
      return 'open';
    case 'CLOSED':
      return 'close';
    default:
      return;
  }
}

export function getSegmentRealizedPnl(item: CommunityFeedItem): number | undefined {
  if (item.positionCardType === 'CLOSED') return Number(item.positionCard.realizedPnl);
}

export function getSegmentRealizedPnlPct(item: CommunityFeedItem): number | undefined {
  if (item.positionCardType === 'CLOSED') return Number(item.positionCard.realizedPnlPct);
}
